<div class="pcl-shell" (click)="fecharDropdown()">
  <div class="container">

    <!-- ── PAGE HEADER (mesmo padrão da Venda) ── -->
    <div class="page-header">
      <div class="page-header-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
          <line x1="3" y1="6" x2="21" y2="6"/>
          <path d="M16 10a4 4 0 0 1-8 0"/>
        </svg>
      </div>
      <div style="flex:1">
        <h1>Compras</h1>
        <p>Consulte e acompanhe as compras geradas</p>
      </div>
      <button type="button" class="btn-novo" (click)="novoPedido.emit()">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
        Nova Compra
      </button>
    </div>

    <!-- ── FILTROS ── -->
    <div class="filtros-bar">

      <!-- Busca rápida — fornecedor/CNPJ/comprador -->
      <div class="filtro-busca-rapida filtro-busca-rapida--destaque">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <input type="text" class="input-busca-rapida"
               placeholder="Filtrar por fornecedor, CNPJ ou comprador..."
               [(ngModel)]="termoBusca"
               (ngModelChange)="onTermoBuscaChange()">
        <button *ngIf="termoBusca" type="button" class="busca-limpar" (click)="termoBusca=''; onTermoBuscaChange()">✕</button>
      </div>

      <!-- Busca por PN / Descrição -->
      <div class="filtro-busca-rapida filtro-busca-pn">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <input type="text" class="input-busca-rapida"
               placeholder="Buscar por PN ou descrição..."
               [(ngModel)]="termoBuscaPn"
               (ngModelChange)="onTermoBuscaPnChange()">
        <button *ngIf="termoBuscaPn" type="button" class="busca-limpar" (click)="termoBuscaPn=''; buscar()">✕</button>
      </div>

      <!-- Separador -->
      <div class="filtro-divisor"></div>

      <div class="filtro-grupo">
        <label>De</label>
        <input type="date" class="input-data" [(ngModel)]="dtDe">
      </div>
      <div class="filtro-grupo">
        <label>Até</label>
        <input type="date" class="input-data" [(ngModel)]="dtAte">
      </div>
      <button type="button" class="btn-buscar" (click)="buscar()" [disabled]="carregando">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        {{ carregando ? 'Buscando...' : 'Buscar' }}
      </button>

      <!-- Separador -->
      <div class="filtro-divisor"></div>

      <!-- Checkbox cancelados -->
      <label class="filtro-toggle" (click)="$event.stopPropagation()">
        <input type="checkbox" [(ngModel)]="mostrarCancelados" (ngModelChange)="onMostrarCanceladosChange()">
        <span class="toggle-label">Exibir cancelados</span>
      </label>
    </div>

    <!-- ── ERRO ── -->
    <div *ngIf="erro" class="alerta alerta-erro">{{ erro }}</div>

    <!-- ── TABELA ── -->
    <div class="tabela-card">
      <div *ngIf="carregando" class="loading-row">
        <div class="spinner"></div>
        <span>Carregando compras...</span>
      </div>

      <div *ngIf="!carregando && pedidosFiltrados.length === 0" class="vazio-row">
        Nenhuma compra encontrada.
      </div>

      <ng-container *ngIf="!carregando && pedidosFiltrados.length > 0">
        <table class="tabela">
          <thead>
            <tr>
              <th class="th-ordenavel" (click)="ordenar('nunota')" title="Clique para ordenar">Nº Único<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='nunota'">{{ ordenarCampo==='nunota' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-center th-ordenavel" (click)="ordenar('status')" title="Clique para ordenar">Status<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='status'">{{ ordenarCampo==='status' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-center th-ordenavel" (click)="ordenar('prioridade')" title="Clique para ordenar">Prioridade<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='prioridade'">{{ ordenarCampo==='prioridade' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-center th-ordenavel" (click)="ordenar('codemp')" title="Clique para ordenar">Empresa<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='codemp'">{{ ordenarCampo==='codemp' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-center th-ordenavel" (click)="ordenar('tipo')" title="Clique para ordenar">Tipo<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='tipo'">{{ ordenarCampo==='tipo' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('dtmov')" title="Clique para ordenar">Solicitação<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='dtmov'">{{ ordenarCampo==='dtmov' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('comprador')" title="Clique para ordenar">Solicitante<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='comprador'">{{ ordenarCampo==='comprador' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('observacao')" title="Clique para ordenar">Observação<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='observacao'">{{ ordenarCampo==='observacao' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('docparc')" title="Clique para ordenar">CNPJ<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='docparc'">{{ ordenarCampo==='docparc' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('fornecedor')" title="Clique para ordenar">Fornecedor<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='fornecedor'">{{ ordenarCampo==='fornecedor' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-right th-ordenavel" (click)="ordenar('vlr')" title="Clique para ordenar">Valor R$<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='vlr'">{{ ordenarCampo==='vlr' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-right th-ordenavel" (click)="ordenar('vlrusd')" title="Clique para ordenar">Valor U$<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='vlrusd'">{{ ordenarCampo==='vlrusd' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('tipoOperacao')" title="Clique para ordenar">Tipo Oper.<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='tipoOperacao'">{{ ordenarCampo==='tipoOperacao' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-center col-acoes-th">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of pedidosPagina" class="linha-clicavel" [class.linha-cancelada]="p.status === 'Cancelado'"
                (dblclick)="onDblClickLinha(p)" title="Duplo clique para editar">
              <td class="col-nunota">{{ p.nunota }}</td>
              <td class="col-center">
                <span class="status-badge" [ngClass]="statusClass(p.gplStatus)">{{ p.gplStatus || '—' }}</span>
              </td>
              <td class="col-center">{{ p.prioridade || '—' }}</td>
              <td class="col-center">
                <span class="empresa-badge"
                  [style.background]="empresa.corClaraPorCodEmp(p.codemp, 0.82)"
                  [style.border-left]="'3px solid ' + empresa.corPorCodEmp(p.codemp)"
                  [title]="p.empresa">{{ fmtCodEmp(p.codemp) }}</span>
              </td>
              <td class="col-center">
                <span class="tipo-badge" [ngClass]="tipoClass(p.tipoGpl)">{{ fmtTipo(p.tipoGpl) }}</span>
              </td>
              <td class="col-data">{{ p.dtmov }}</td>
              <td class="col-vend">{{ p.comprador }}</td>
              <td class="col-obs">
                <span class="obs-texto" [title]="p.observacao">{{ p.observacao }}</span>
              </td>
              <td class="col-cnpj">{{ p.docparc }}</td>
              <td class="col-cliente">{{ p.fornecedor }}</td>
              <td class="col-right col-valor">{{ fmtBrl(vlrTotal(p)) }}</td>
              <td class="col-right col-valor">{{ fmtUsd(vlrTotalUsd(p)) }}</td>
              <td class="col-tipo">{{ p.tipoOperacao }}</td>
              <td class="col-center col-acoes" (click)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()">
                <div class="dropdown-wrapper">
                  <button class="btn-dots" [class.btn-dots-ativo]="dropdownAberto === p.nunota" (click)="toggleDropdown($event, p)" title="Ações">⋮</button>
                  <div class="dropdown-menu" *ngIf="dropdownAberto === p.nunota" (click)="$event.stopPropagation()">
                    <div class="dropdown-header">Compra #{{ p.nunota }}</div>
                    <button class="dropdown-item item-editar"
                      (click)="editarPedido.emit(p.nunota); dropdownAberto = null">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                      Editar Compra
                    </button>
                    <button *ngFor="let relatorio of relatoriosImpressao" class="dropdown-item"
                      (click)="imprimirPedido.emit({nunota: p.nunota, view: relatorio.view}); dropdownAberto = null">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9V3h12v6"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
                      {{ relatorio.titulo }}
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- ── RODAPÉ: total + paginação ── -->
        <div class="tabela-rodape">
          <span class="rodape-total">{{ pedidosFiltrados.length }} compra{{ pedidosFiltrados.length !== 1 ? 's' : '' }}</span>

          <div class="rodape-paginacao">
            <div class="por-pagina">
              <span>Exibir</span>
              <select [(ngModel)]="itensPorPagina" (ngModelChange)="onItensPorPaginaChange()" class="sel-pagina">
                <option *ngFor="let op of opcoesPorPagina" [value]="op">{{ op }}</option>
              </select>
              <span>por página</span>
            </div>

            <div class="pag-controles">
              <button class="pag-btn" (click)="irParaPagina(1)" [disabled]="paginaAtual === 1" title="Primeira">«</button>
              <button class="pag-btn" (click)="irParaPagina(paginaAtual - 1)" [disabled]="paginaAtual === 1" title="Anterior">‹</button>

              <ng-container *ngFor="let p of paginas">
                <button class="pag-btn" [class.pag-ativo]="p === paginaAtual" (click)="irParaPagina(p)">{{ p }}</button>
              </ng-container>

              <button class="pag-btn" (click)="irParaPagina(paginaAtual + 1)" [disabled]="paginaAtual === totalPaginas" title="Próxima">›</button>
              <button class="pag-btn" (click)="irParaPagina(totalPaginas)" [disabled]="paginaAtual === totalPaginas" title="Última">»</button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

  </div>
</div>
